import './SupportStatusToggle.scss';
import { Box, Button, Typography } from '@mui/material';
import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const SupportStatusToggle = ({ statusType, setStatus, data }) => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const navigateToStatus = (status) => {
    let languagePrefix: string;

    switch (i18n.language) {
      case 'fr':
        languagePrefix = 'fr';
        break;
      default:
        languagePrefix = 'en';
        break;
    }
    const statusPath = status === 'Production' ? 'PROD' : 'GOLD';
    navigate(`/${languagePrefix}/support/statusMonitoring/${statusPath}`);
    setStatus(status);
  };

  useEffect(() => {
    const currentPath = location.pathname;
    const isGold = currentPath.includes('GOLD');
    const status = isGold ? 'Gold' : 'Production';
    if (status !== statusType) {
      setStatus(status);
    }
  }, [location, setStatus, statusType]);

  return (
    <Box className="toggleContainer">
      <Box>
        <Typography className="statusHeaderText">{data.title}</Typography>
        <Typography className="statusSubText">{data.description}</Typography>
      </Box>
      <Box className="toggle-group">
        <Box
          className="toggle"
          sx={{
            transform: `translateX(${statusType === 'Production' ? 0 : '100px'
              })`
          }}
        />
        <Button
          variant="text"
          sx={{
            color: statusType === 'Production' ? '#ffffff' : 'black',
            textTransform: 'none',
            fontWeight: 400,
            fontSize: '14px'
          }}
          onClick={() => {
            setStatus('Production');
            navigateToStatus('Production');
          }}
        >
          {data.toggle[0]}
        </Button>
        <Button
          variant="text"
          sx={{
            color: statusType === 'Gold' ? '#ffffff' : 'black',
            textTransform: 'none',
            fontWeight: 400,
            fontSize: '14px'
          }}
          onClick={() => {
            setStatus('Gold');
            navigateToStatus('Gold');
          }}
        >
          {data.toggle[1]}
        </Button>
      </Box>
    </Box>
  );
};

export default SupportStatusToggle;
